module.exports = __webpack_public_path__ + "static/media/Post.a85524d2.svg";